import * as Types from '@haaretz/s-fragments/Types';


/**
 * -----------------------------------------------------------------------------
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 * -----------------------------------------------------------------------------
 * This file was automatically generated by GraphQL Codegen.
 * Any manual changes will be overwritten.
 * -----------------------------------------------------------------------------
 */

export type SelectedOfferFragment = (
  { contentId: string, periodCalc: number, prices: Array<number>, productNumber: number, paymentType: Types.PaymentType, promotionNumber: number, saleCode: number, thankYouMailTemplate: string, offerType: Types.OfferType, currency: string }
  & { __typename: 'PurchaseOffer' }
);


export type SelectedOfferFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SelectedOfferFragmentGql = `
    fragment SelectedOfferFragment on PurchaseOffer {
  __typename
  contentId
  periodCalc
  prices
  productNumber
  paymentType
  promotionNumber
  saleCode
  thankYouMailTemplate
  offerType
  currency
}
    `;